module.exports = __webpack_public_path__ + "static/media/3. Escapando, Esmalte y óleo en tela, 60 x 80 cm, 2018 copy.099c2de9.png";